export enum EDashboardReturnLinkEnum {
    Integrator = 6,
    Partner = 7,
    Internal = 8,
}